export default {
  tags: {
    preferred: 'Préféré',
  },
};
